'use client'

import { cardsPerRowMap, containerSizeMap, pyMap } from '@lib/token-maps'
import { routeMapper } from '@lib/menu-item-mapper'
import type { TypeCardIconBlockFields, TypeCardIconItemFields } from '@lib/generated-types'
import { CardIcon, CardIconBlock as Block } from '@shc/ui'
import Analytics from '@components/analytics'
import { getIconFromContentful } from '@lib/icons'
import type { SPEvent, SPContext } from '@hooks/use-analytics'

const CardIconBlock = ({
  blockAlignment,
  cardAlignment,
  cards,
  columnsMax,
  paddingBottom,
  paddingTop,
  width,
}: TypeCardIconBlockFields) => {
  const analyticsEvent = (label: string | undefined, link: string, fields: any, sys: any) => {
    if( !label || !link ){
      return {}
    }
    return {
      click: {
        name: 'component_click',
        data: {},
      } as SPEvent,
      contexts: [
        {
          name: 'component',
          data: {
            component_text: label,
            component_url: link,
          },
        },
        {
          name: 'content',
          data: {
            content_type: sys.contentType.sys.id,
            content_internal_name: fields.title,
            content_entry_id: sys.id,
            content_level: 'item',
          },
        }
      ] as SPContext[],
    }
  }

  return (

      <Block
        cardAlignment={cardAlignment}
        cardsPerRow={cardsPerRowMap[columnsMax]}
        containerAlignment={blockAlignment}
        containerSize={containerSizeMap[width]}
        paddingBottom={pyMap[paddingBottom]}
        paddingTop={pyMap[paddingTop]}>
        {cards.map(({ fields, sys }) => {
          const fieldsData = fields as TypeCardIconItemFields
          const { route, isInternal } = routeMapper(fieldsData.link, fieldsData.anchorOrExternalLink)
          const btnLabel = fieldsData.linkLabel
          const contentfulIcon = getIconFromContentful(fieldsData.icon)

          return (
            <CardIcon
              description={fieldsData.summary}
              heading={fieldsData.title}
              button={
                btnLabel && {
                  href: route,
                  label: btnLabel,
                  target: isInternal ? undefined : '_blank'
                } as any
              }
              icon={!!contentfulIcon ? contentfulIcon[1] : undefined}
              key={sys.id}
              slotProps={{
                buttonContainer: analyticsEvent(
                  btnLabel || fieldsData.title,
                  route || fieldsData.title,
                  fields,
                  sys
                )
              }}
              slots={{
                buttonContainer: Analytics
              }}
            />
          )
        })}
      </Block>

  )
}

export default CardIconBlock
